/**
 * @file Contains redux helpers for openComposeButton container
 */
import { MapStateToProps } from 'react-redux';

import AppState from '../../models/state';

import { getIsDraftChanged } from '../compose/helpers';

import { OwnProps, StateProps } from './types';

/**
 * Map Redux state to compose props
 *
 * @param appState                   Global Redux state
 * @param appState.drafts            Drafts in Redux store
 * @param appState.draftsAttachments Drafts attachments in Redux store
 * @param ownProps                   Props passed to compose container
 * @param ownProps.nodeType          The ID of the draft
 * @returns                          Props to add to compose
 */
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = ({ drafts, draftsAttachments }, { nodeType }) => ({
  isDraftChanged: getIsDraftChanged(
    drafts.get(nodeType),
    draftsAttachments.get(nodeType),
  ),
});
